<template>
  <el-table-column
    prop="nav_status"
    sortable="custom"
    label="NAV státusz"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag
        v-for="status in statuses"
        v-if="status.key === scope.row.nav_status && scope.row.is_invoice"
        size="small"
        :type="status.tag"
      >
        <i :class="status.icon"></i> {{ status.title }}
      </el-tag>
      <el-tag
        v-if="!scope.row.is_invoice"
        size="small"
        type="info"
      >
        Nem számla
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'nav_status',
  data() {
    return {
      navError: null,
      statuses: [
        {
          key: 'processing',
          tag: 'info',
          title: 'Feldolgozás alatt',
          icon: 'el-icon-loading',
        },
        {
          key: 'sent-error',
          tag: 'danger',
          title: 'Elutasítva',
          icon: 'el-icon-error',
        },
        {
          key: 'aborted',
          tag: 'danger',
          title: 'Elutasítva',
          icon: 'el-icon-error',
        },
        {
          key: 'sent-success',
          tag: 'success',
          title: 'Elküldve',
          icon: 'el-icon-check',
        },
        {
          key: 'sent-warning',
          tag: 'warning',
          title: 'Elküldve hibával',
          icon: 'el-icon-warning',
        },
      ],
    };
  }
};
</script>
